module.exports = "../static/media/banner_poster.4637d1d5.png";